<template>
    <div>
        <div class="row">

            <div class="col-md-12">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'home'}">{{$t("inicio")}}</router-link>
                        </li>
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'informes'}">{{$t("informes")}}</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">{{$t('tiempoMedioCocina')}}</li>
                    </ol>
                </nav>
            </div>

            <div class="col-md-12">
                <div class="card">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="listBusiness">{{$t("negocio")}}</label>
                                <el-select class="select-default"
                                           size="large"
                                           v-model="idBusiness"
                                           filterable
                                           :placeholder="$t('seleccionaNegocio')"
                                           @change="getKds()">
                                    <el-option v-for="business in listBusinesses"
                                               class="select-primary"
                                               :value="business.id"
                                               :label="business.establishmentName"
                                               :key="business.establishmentName">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>

                        <div class="col-md-2">
                            <div class="form-group">
                                <label>{{$t("fechaInicio")}}</label>
                                <datetime
                                        value-zone="Europe/Madrid"
                                        :auto="true"
                                        class="theme-numier"
                                        format="dd-MM-yyyy"
                                        :title="$t('fechaInicio')"
                                        :phrases="{ok: $t('aceptar'), cancel: $t('salir')}"
                                        input-class="form-control"
                                        v-model="datefrom"></datetime>
                            </div>
                        </div>

                        <div class="col-md-2">
                            <div class="form-group">
                                <label>{{$t("fechaFin")}}</label>
                                <datetime
                                        value-zone="Europe/Madrid"
                                        :auto="true"
                                        class="theme-numier"
                                        :title="$t('fechaFin')"
                                        format="dd-MM-yyyy"
                                        :phrases="{ok: $t('aceptar'), cancel: $t('salir')}"
                                        input-class="form-control"
                                        v-model="dateto"></datetime>
                            </div>
                        </div>

                        <div class="col-md-2">
                            <label>&nbsp;</label>
                            <div class="form-group">
                                <button class="btn btn-primary" @click="getKds()">
                                    <img src="static/img/sync.gif" alt="" v-if="loading" width="15">
                                    {{$t("consultar")}}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <template v-if="listKds.length>0">
                <div class="col-md-8">
                    <template>
                        <div class="row justify-content-between div-export">
                            <div class="col-md-6">
                                <el-dropdown>
                                    <el-button type="primary" size="small">
                                        <i class="fa fa-file"></i>
                                        {{$t("exportarInforme")}} <i class="el-icon-arrow-down el-icon--right"></i>
                                    </el-button>
                                    <el-dropdown-menu slot="dropdown">
                                        <a :href="urlExportPDF">
                                            <el-dropdown-item class="text-danger">
                                                <strong><i class="fa fa-file-pdf"></i> {{$t("exportarPdf")}}</strong>
                                            </el-dropdown-item>
                                        </a>
                                        <a :href="urlExportExcel">
                                            <el-dropdown-item class="text-success">
                                                <strong><i class="fa fa-file-excel"></i> {{$t("exportarExcel")}}</strong>
                                            </el-dropdown-item>
                                        </a>
                                    </el-dropdown-menu>
                                </el-dropdown>

                            </div>
                        </div>

                        <div class="table-responsive" style="overflow: auto">

                            <table class="table table-bordered table-striped text-nowrap">
                                <thead class="thead-dark">
                                <tr>
                                    <th>
                                        {{$t('fecha')}}
                                    </th>
                                    <th>
                                        {{$t('nComandas')}}
                                    </th>
                                    <th>
                                        {{$t('tiempoMedio')}}
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="kds in listKds">
                                    <td><span :class="getClassDay(kds.inicioDate)">{{kds.inicioDate | getDia}}
                                    {{kds.inicioDate | parseDate}}</span></td>
                                    <td>{{kds.numCabs}}</td>
                                    <td>
                                        <template v-if="kds.numCabs!==0 && kds.diffHor!==0">{{kds.diffHor/60 /
                                            kds.numCabs |
                                            timago}}
                                        </template>
                                        <template v-else>0</template>
                                    </td>
                                </tr>

                                </tbody>
                                <tfoot>
                                <tr>
                                </tr>
                                </tfoot>
                            </table>
                        </div>

                    </template>
                </div>
            </template>
            <template v-else>
                <div class="col-md-12">
                    <div class="alert alert-danger" role="alert">
                        {{$t('noHayComandasEnviadasAlKdsEnEsteRangoDeFechas')}}
                    </div>
                </div>
            </template>
            <div v-show="listKds.length>0" class="col-md-4">

                <div class="card">

                    <div class="chart-container col-md-12" style="height:300px; width: 100%">
                        <canvas id="chart"></canvas>
                    </div>

                </div>

            </div>

        </div>


    </div>
</template>
<script>
    import Datepicker from 'vuejs-datepicker';
    import {DatePicker, Select, Option, Dropdown, DropdownItem, DropdownMenu, Button} from 'element-ui'
    import swal from 'sweetalert2'
    import Datetime from 'vue-datetime'
    import moment from 'moment'
    import Ticket from '../../../Widgets/Ticket.vue'

    export default {
        created() {
            this.loading = true;
            this.$store.dispatch("setNameRoute", "Tiempo medio cocina");
            this.getBusiness();

            if (this.$store.getters.dateTo && this.$store.getters.dateFrom) {
                this.datefrom = this.$store.getters.dateFrom;
                this.dateto = this.$store.getters.dateTo;
            }
        },
        components: {
            [DatePicker.name]: DatePicker,
            [Select.name]: Select,
            [Dropdown.name]: Dropdown,
            [DropdownItem.name]: DropdownItem,
            [DropdownMenu.name]: DropdownMenu,
            [Button.name]: Button,
            [Option.name]: Option,
            [Datetime]: Datetime,
            'ticket': Ticket
        },
        data() {
            return {

                //GENERAL
                loading: false,
                datefrom: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString(),
                dateto: new Date().toISOString(),
                listBusinesses: [],
                idBusiness: this.$route.params.idBusiness,


                //CHART
                objectChart: null,
                contador: 0,

                listKds: [],

                //ORDENAR
                ordenarFecha: 0,
                ordenarFactura: 0,
                ordenarTipo: 0,
                ordenarTotal: 0,

            }
        },
        computed: {

            /*totalDet() {

                let total = 0;

                this.listDetallesCab.forEach(function (x) {

                    total += x.amount
                });

                return total;

            },*/

            urlExportPDF() {

                return this.$store.getters.apiUrl+"/sales/exportTiempoMedioCocina/PDF?idBusiness=" + this.idBusiness + "&datefrom=" + moment(this.datefrom).startOf("day").unix() + "&dateto=" + moment(this.dateto).endOf("day").unix() + "&jwt=" + this.$store.getters.jwt
            },
            urlExportExcel() {
                return this.$store.getters.apiUrl+"/sales/exportTiempoMedioCocina/Excel?idBusiness=" + this.idBusiness + "&datefrom=" + moment(this.datefrom).startOf("day").unix() + "&dateto=" + moment(this.dateto).endOf("day").unix() + "&jwt=" + this.$store.getters.jwt
            },

        },
        methods: {

            //GENERAL
            getBusiness() {
                var config = {
                    params: {
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
                    .then(function (response) {

                        vm.listBusinesses = response.data.result;

                        if (vm.$store.getters.idBusiness) {
                            vm.idBusiness = vm.$store.getters.idBusiness;
                        }
                        else {

                            vm.idBusiness = response.data.result[0].id;
                        }

                        vm.getKds();
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },

            //ORDENAR

            sortedArrayASC: function (nameAtributo, index) {


                switch (nameAtributo) {

                    case 1:

                        this.ordenarFecha = 1;

                    function compareDate(a, b) {

                        if (a.date.toUpperCase() < b.date.toUpperCase())
                            return -1;
                        if (a.date.toUpperCase() > b.date.toUpperCase())
                            return 1;
                        return 0;
                    }

                        return this.dateInform[index].headers.sort(compareDate);

                    case 2:

                        this.ordenarFactura = 1;

                    function compareFactura(a, b) {

                        if (a.idCode.toUpperCase() < b.idCode.toUpperCase())
                            return -1;
                        if (a.idCode.toUpperCase() > b.idCode.toUpperCase())
                            return 1;
                        return 0;
                    }

                        return this.dateInform[index].headers.sort(compareFactura);

                    case 3:

                        this.ordenarTipo = 1;

                    function compareTipo(a, b) {

                        if (a.status.toUpperCase() < b.status.toUpperCase())
                            return -1;
                        if (a.status.toUpperCase() > b.status.toUpperCase())
                            return 1;
                        return 0;
                    }

                        return this.dateInform[index].headers.sort(compareTipo);


                    case 4:

                        this.ordenarTotal = 1;

                    function compareTotal(a, b) {

                        if (a.amount < b.amount)
                            return -1;
                        if (a.amount > b.amount)
                            return 1;
                        return 0;
                    }

                        return this.dateInform[index].headers.sort(compareTotal);


                }

            },
            sortedArrayDESC: function (nameAtributo, index) {


                switch (nameAtributo) {

                    case 1:

                        this.ordenarFecha = 0;

                    function compareDate(a, b) {

                        if (a.date.toUpperCase() > b.date.toUpperCase())
                            return -1;
                        if (a.date.toUpperCase() < b.date.toUpperCase())
                            return 1;
                        return 0;
                    }

                        return this.dateInform[index].headers.sort(compareDate);

                    case 2:

                        this.ordenarFactura = 0;

                    function compareFactura(a, b) {

                        if (a.idCode.toUpperCase() > b.idCode.toUpperCase())
                            return -1;
                        if (a.idCode.toUpperCase() < b.idCode.toUpperCase())
                            return 1;
                        return 0;
                    }

                        return this.dateInform[index].headers.sort(compareFactura);

                    case 3:

                        this.ordenarTipo = 0;

                    function compareTipo(a, b) {

                        if (a.status.toUpperCase() > b.status.toUpperCase())
                            return -1;
                        if (a.status.toUpperCase() < b.status.toUpperCase())
                            return 1;
                        return 0;
                    }

                        return this.dateInform[index].headers.sort(compareTipo);


                    case 4:

                        this.ordenarTotal = 0;

                    function compareTotal(a, b) {

                        if (a.amount > b.amount)
                            return -1;
                        if (a.amount < b.amount)
                            return 1;
                        return 0;
                    }

                        return this.dateInform[index].headers.sort(compareTotal);


                }

            },


            getKds() {

                if (this.datefrom === null || this.dateto === null) {
                    swal({
                        title: this.$t('ups'),
                        text: this.$t('seleccioneUnaFechaDeInicioYUnaFechaDeFin'),
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });

                } else {

                    let secondsDesde = moment(this.datefrom).startOf("day").unix();
                    let secondsHasta = moment(this.dateto).endOf("day").unix();

                    if (secondsHasta < secondsDesde) {
                        swal({
                            title: this.$t('ups'),
                            text: this.$t('laFechaDeInicioNoPuedeSerPosteriorALaDeFin'),
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });
                    } else {
                        this.$store.dispatch("setDateTo", this.dateto);
                        this.$store.dispatch("setDateFrom", this.datefrom);

                        this.loading = true;

                        const controller = 'getTiempoMedioCocina';


                        var config = {
                            params: {
                                idBusiness: this.idBusiness,
                                datefrom: moment(this.datefrom).startOf("day").unix(),
                                dateto: moment(this.dateto).endOf("day").unix(),
                                jwt: this.$store.getters.jwt
                            },
                            headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                        };

                        let vm = this;
                        this.$store.dispatch("setIdBusiness", this.idBusiness);
                        this.axios.get(this.$store.getters.apiUrl + "sales/" + controller, config)
                            .then(function (response) {
                                if (response.data.response) {

                                    vm.listKds = response.data.result;

                                    vm.initChart();

                                }
                                else {

                                    swal({
                                        title: vm.$t('atencion'),
                                        text: response.data.message,
                                        confirmButtonClass: 'btn btn-info btn-fill',
                                        type: 'error'
                                    });

                                }
                                vm.loading = false;

                            })
                            .catch(function (error) {
                                console.log(error);
                            });
                    }
                }


            },

            getClassDay(date) {
                var classDay = "";
                var humanDate = moment.unix(date);
                var dia = moment(humanDate).format("d");

                if (dia === "0") {
                    classDay = "sunday";
                } else if (dia == 5 || dia == 6) {
                    classDay = "fridaySaturday";
                }

                return classDay;
            },


            initChart() {

                var labels = this.listKds.map(function (x) {

                    let date = 0;

                    /*if (x.diffHor !== 0) {
                        date = x.diffHor / 60 / x.numCabs;

                        var hours = Math.floor(date / 60);
                        var minutes = Math.floor((date % 60));

                        return hours + " h. " + minutes + " min.";
                    }
                    else {
                        return 0;
                    }*/


                    return x.numCabs;
                });

                var data = this.listKds.map(function (x) {


                    return Math.floor(x.diffHor / 60 / x.numCabs);

                    /*return x.numCabs;*/
                });


                var randomColor = require('randomcolor');

                var colors = randomColor({luminosity: 'dark', count: labels.length, format: 'rgb'});

                let backgroundColors = colors.map(function (x) {
                    let xcolors = x.substring(x.indexOf("(") + 1, x.length - 1).split(",");
                    return "rgba(" + xcolors[0] + "," + xcolors[1] + "," + xcolors[2] + ", 0.6)";
                });

                let borderColors = colors.map(function (x) {
                    let xcolors = x.substring(x.indexOf("(") + 1, x.length - 1).split(",");
                    return "rgba(" + xcolors[0] + "," + xcolors[1] + "," + xcolors[2] + ", 0.3)";
                });

                let hoverBackgroundColors = colors.map(function (x) {
                    let xcolors = x.substring(x.indexOf("(") + 1, x.length - 1).split(",");
                    return "rgba(" + xcolors[0] + "," + xcolors[1] + "," + xcolors[2] + ", 1)";
                });

                if (this.contador == 0) {

                    if (this.listKds.length > 0) {
                        this.objectChart = new Chart("chart", {

                            type: 'line',
                            data: {
                                labels: labels,
                                datasets: [{
                                    data: data,
                                    backgroundColor: backgroundColors,
                                    borderColor: borderColors,
                                    hoverBackgroundColor: hoverBackgroundColors,
                                    borderWidth: 1,
                                }]
                            },
                            options: {
                                legend: {
                                    display: false,
                                    position: 'bottom',
                                },
                                maintainAspectRatio: false,

                            }
                        });


                        this.contador++;
                    }
                }
                else {

                    this.objectChart.destroy();

                    this.objectChart = new Chart('chart', {

                        type: 'line',
                        data: {
                            labels: labels,
                            datasets: [{
                                data: data,
                                backgroundColor: backgroundColors,
                                borderColor: borderColors,
                                hoverBackgroundColor: hoverBackgroundColors,
                                borderWidth: 1,
                            }]
                        },
                        options: {
                            legend: {
                                display: false,
                                position: 'bottom',
                            },
                            maintainAspectRatio: false,


                        }
                    });

                }
            }

        }
    }
</script>

<style scoped>

    a li {
        color: #111;
    }

    .card {
        padding: 20px;
    }

    .div-export {
        margin-bottom: 10px;
    }

    .sunday {
        color: rgb(128, 0, 0);
    }

    .fridaySaturday {
        color: rgb(0, 128, 64);
    }

</style>




// WEBPACK FOOTER //
// src/pages/Dashboard/Informes/KDS/TiempoMedioPreparacion.vue